import module from 'module';
import _ from 'lodash';
import moment from 'moment';
import {isCorporate, mapSignatoryToOwnership, multipleAccountOwnershipsEnabled} from '../../common/casa-product-util';
import CASE_CLASS_CODE_VALUES from '../../common/types/casa-class-code-labels.js'
import BigNumber from "bignumber.js";

const templateUrl = require('./new-term-deposit-details.template.html');
module.component('customerTermDepositCreateDetails', {
  templateUrl: templateUrl,
  controller: function ($route, $location, confirmationTemplate, authentication, command, casaTypesCache, interestBoardService,
                        customerCache, termDepositsService, customerDepositService, branchService, $scope, dict) {
    const that = this;

    const customerId = $route.current.params['customerId'];
    const termDepositProductId = $route.current.params['termDepositTypeId'];
    const preterminationFirstHalfMultipler = new BigNumber(0.25).toNumber();
    const preterminationSecondHalfMultipler = new BigNumber(0.50).toNumber();

    that.casaClassCodeValues = CASE_CLASS_CODE_VALUES;
    that.depositAccounts = [];
    that.termDepositProduct = {};
    that.termDepositInterestBoard = {};
    that.overrideTaxExemption = false;
    that.overrideInterestRate = false;
    that.pdicCasaTypes = [];
    that.termDeposit = undefined;
    that.accounts = [];
    that.selectedRelatedAccount = {};

    $scope.$watchCollection('$ctrl.termDeposit.ownership', () => {
      if (that.termDeposit) {
        that.cifIds = that.termDeposit.ownership.map(o => Number(o.customerId));
        if (that.profile.relatives && that.profile.relatives.length > 0) {
          let relativesCifIds = that.profile.relatives.map(r => Number(r.relativeCustomerId));
          that.cifIds = that.cifIds.concat(relativesCifIds);
        }
        searchAccounts(that.termDepositProduct.interCustomerTransferAllowed);
      }
    });

    $scope.$watch('$ctrl.termDeposit.depositInterest.interestRate', () => {
      if (that.termDeposit && that.termDeposit.depositInterest.specialInterestRate && that.termDeposit.depositInterest.interestRate) {
        const interestRate = new BigNumber(that.termDeposit.depositInterest.interestRate);
        that.termDeposit.depositInterest.preterminationFirstHalfInterestRate = interestRate.mul(preterminationFirstHalfMultipler).toNumber();
        that.termDeposit.depositInterest.preterminationSecondHalfInterestRate = interestRate.mul(preterminationSecondHalfMultipler).toNumber();
        that.termDeposit.depositInterest.preterminationSecondHalfInterestRate = interestRate.mul(preterminationSecondHalfMultipler).toNumber();
      }
    });

    /**
     * Multiple account ownership enabled when:
     * 1. Customer is INDIVIDUAL
     * 2. Casa PDIC casa types allows this feature.
     */
    that.multipleAccountOwnershipEnabled = false;

    that.cycleTypes = [{
      label: 'Days',
      value: 'DAY'
    }, {
      label: 'Weeks',
      value: 'WEEK'
    }, {
      label: 'Months',
      value: 'MONTH'
    }, {
      label: 'Quarters',
      value: 'QUARTER'
    }, {
      label: 'Years',
      value: 'YEAR'
    }];

    that.selectAccountConfig = {
      placeholder: 'Select account',
      searchField: ['productNumber'],
      valueField: 'id',
      labelField: 'label',
      maxItems: 1
    };

    const searchAccounts = (fetchRelatedCustomerAccounts) => {
      customerDepositService.searchDeposits(
        // term deposit owner, co-owner, and relatives Ids
        that.cifIds,
        // valid deposit account statuses
        ['ACTIVE', 'INACTIVE'],
        // if true -> fetch deposit accounts of related customers,
        fetchRelatedCustomerAccounts,
        // search success callback
        deposits => that.depositAccounts = deposits
      );
    };

    const s1 = casaTypesCache.toObservable().subscribe(casaTypes => {
      that.casaTypes = casaTypes;
      that.pdicCasaTypes = _.filter(that.casaTypes, {'regulatorType': 'PDIC'});
    });

    that.findSignatoryNames = () => {
      let signatoryTypeId = _.find(dict.RELATIVE_TYPE, {code: 'SIGNATORY'}).id;
      that.signatoryRelatives = _.filter(that.profile.relatives, {typeId: signatoryTypeId});
    };

    that.createInterestBoard = (termDepositProduct) => {
      if (termDepositProduct) {
        that.termDepositInterestBoard.basic = termDepositProduct.interestBoards.find(board => board.rateType === 'BASIC');
        that.termDepositInterestBoard.preterminationFirstHalf = termDepositProduct.interestBoards.find(board => board.rateType === 'PRETERMINATION_ON_FIRST_HALF');
        that.termDepositInterestBoard.preterminationSecondHalf = termDepositProduct.interestBoards.find(board => board.rateType === 'PRETERMINATION_ON_SECOND_HALF');
        that.termDepositInterestBoard.overmature = termDepositProduct.interestBoards.find(board => board.rateType === 'OVERMATURE');
      }
    };

    const s2 = customerCache.profile(customerId).toObservable()
      .combineLatest(termDepositsService.toObservable(), (profile, products) => {
        that.profile = profile;

        dict.onLoadingComplete(() => {
          that.findSignatoryNames();
        });

        return products;
      }).combineLatest(branchService.toObservable(), (products, branches) => {
        const authBranch = _.find(branches, {id: authentication.context.branchId});
        if (authBranch) that.postingDate = moment(authBranch.postingDate).toDate();
        that.ownerBranch = branches.find(b => b.id = that.profile.branchId);
        return products;
      })
      .subscribe(products => {
        const termDepositProduct = _.find(products, {id: ~~termDepositProductId});
        that.termDepositProduct = termDepositsService.enrichWithStrategiesDescription(termDepositProduct);
        that.termDepositProduct.interestRange = interestBoardService.formatInterestRateRangeForRateType(that.termDepositProduct.interestBoards);

        that.createInterestBoard(that.termDepositProduct);

        const owner = {
          birthDate: that.profile.individualData ? that.profile.individualData.birthDate : null,
          branchId: that.profile.branchId,
          branchName: that.ownerBranch.name,
          customerId: customerId,
          customerNumber: that.profile.customerNumber,
          effectiveName: that.profile.effectiveName,
          ownershipType: 'OWNER'
        };

        that.termDeposit = {
          customerId: customerId,
          typeId: that.termDepositProduct.id,
          pdicTypeId: null,
          depositTerm: null,
          maturityStrategy: _.get(that.termDepositProduct, 'maturityStrategies[0].value'),
          creditingStrategy: _.get(that.termDepositProduct, 'creditingStrategies[0].value'),
          relatedAccountId: null,
          taxExempted: false,
          casaClassCode: 'INDIVIDUALS',
          creditingInterval: null,
          creditingCycleType: null,
          ownership: [owner],
          depositInterest: {
            specialInterestRate: false,
            interestRate: null,
            preterminationFirstHalfInterestRate: null,
            preterminationSecondHalfInterestRate: null,
            overmatureInterestRate: null
          }
        };
      });

    that.onDepositTermChange = () => {

      const deposit = that.termDeposit;
      const term = deposit.depositTerm;

      // If tax exemption marker is set to true -> keep it
      // Otherwise set marker value to false (to prevent undefined/null)
      deposit.taxExempted = deposit.taxExempted || false;

      // Update tax exemption marker
      if (term && !that.overrideTaxExemption) {
        that.termDeposit.taxExempted = term >= that.termDepositProduct.taxExemptionThreshold;
      }

      // Recalculate maturity date
      that.termDeposit.maturityDate = null;
      if (term && term > 0 && that.postingDate) {
        that.termDeposit.maturityDate = moment(that.postingDate).add(term, 'days').toDate();
      }
    };

    that.redirectBack = () => $location.path(`/customer/${customerId}/term-deposits/create`);

    that.open = () => {

      if (!that.termDeposit.depositInterest.specialInterestRate) {
        that.resetInterestRates();
      }

      that.termDeposit.signatoryIds = that.termDeposit.signatoryIds || [];
      const deposit = angular.copy(that.termDeposit);
      // Add signatories to owners
      let signatories = that.signatoryRelatives
        .filter(s => that.termDeposit.signatoryIds.includes(s.id))
        .map(sig => mapSignatoryToOwnership(sig));
      deposit.ownership = deposit.ownership.concat(signatories);

      // Calculate interest range for the deposit
      const boards = that.termDepositProduct.interestBoards;
      const rateRange = interestBoardService.calculateInterestRateRange(boards, deposit.depositTerm);

      confirmationTemplate({
        question: `Do you want to open the term deposit?`,
        details: [
          {label: 'Product name', description: that.termDepositProduct.productDefinition.productName},
          {label: 'Deposit term', description: `${deposit.depositTerm} days`},
          {label: 'Min interest rate', description: `${rateRange.minRate}%`},
          {label: 'Max interest rate', description: `${rateRange.maxRate}%`},
          {label: 'Special interest rate', description: deposit.depositInterest.specialInterestRate},
          {label: 'Interest rate', description: `${deposit.depositInterest.interestRate}%`}
        ],
        yesCallback: () => {
          command.execute('CreateDeposit', deposit, {nxLoaderText: 'Creating deposit'}).success(() => {
            customerCache.termDeposits(customerId).refetch();
            $location.path(`/customer/${customerId}/term-deposits`)
          });
        }
      });
    };

    that.pdicCasaTypesChanged = () => {
      that.multipleAccountOwnershipEnabled = multipleAccountOwnershipsEnabled(that.profile, that.termDeposit, that.pdicCasaTypes);
      that.isCorporate = isCorporate(that.profile, that.termDeposit, that.pdicCasaTypes);
      if (!that.isCorporate) {
        that.termDeposit.signatoryIds = [];
      }
    };

    that.resetInterestRates = () => {
      that.termDeposit.depositInterest.interestRate = that.termDepositInterestBoard.basic.defaultRate;
      that.termDeposit.depositInterest.overmatureInterestRate = that.termDepositInterestBoard.overmature.defaultRate;
      that.termDeposit.depositInterest.preterminationFirstHalfInterestRate = that.termDepositInterestBoard.preterminationFirstHalf.defaultRate;
      that.termDeposit.depositInterest.preterminationSecondHalfInterestRate = that.termDepositInterestBoard.preterminationSecondHalf.defaultRate;
    };

    that.$onDestroy = () => {
      s1.unsubscribe();
      s2.unsubscribe();
    };
  }
});
